import { Alert } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import announcementsService from '../services/announcementsService';

export default function AnnouncementBanner() {
  const { data: announcement } = useQuery({
    queryKey: ['announcement-active'],
    queryFn: () => announcementsService.getActive(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  if (!announcement) return null;

  return (
    <Alert severity={announcement.severity || 'info'} sx={{ borderRadius: 0 }}>
      {announcement.message}
    </Alert>
  );
}
